import { Router } from "@angular/router";
import { EnumService } from "./../services/enum.service";
import { Component, Input, OnInit } from "@angular/core";
import { BanerItemsIncio } from "src/app/modals/baner-items-incio";
@Component({
  selector: "app-blog-section",
  templateUrl: "./blog-section.component.html",
  styleUrls: ["./blog-section.component.sass"],
})
export class BlogSectionComponent implements OnInit {
  constructor(private enumService: EnumService, private router: Router) {}
  bannerContent: any[] = [];
  bannerList: any[] = [];
  contenedor: any[] = [];

  ngOnInit() {
    let contador: any = 0;
    let banner: any[] = [];

    this.enumService.getBannerBPB().subscribe((resp: any) => {
      // console.log(resp)
      let cantidadItems: number = resp.length;
      for (let i = 0; i < cantidadItems; i++) {
        contador++;

        if (contador <= 3 && resp[i].Habilitado) {
          banner.push({
            idBanner: resp[i].idBanner,
            TipoBanner: resp[i].TipoBanner,
            TipoBannerNom: resp[i].TipoBannerNom,
            TituloBanner: resp[i].TituloBanner,
            SubtituloBanner: resp[i].SubtituloBanner,
            AccionBanner: resp[i].AccionBanner,
            VigenciaBanner: resp[i].VigenciaBanner,
            idCat: resp[i].idCat,
            Codigo: resp[i].Codigo,
            DenoCat: resp[i].DenoCat,
            idMarca: resp[i].idMarca,
            Marca: resp[i].Marca,
            idItem: resp[i].idItem,
            CodigoItem: resp[i].CodigoItem,
            NombreItm: resp[i].NombreItm,
            CodigoBarras: resp[i].CodigoBarras,
            UniMed: resp[i].UniMed,
            UniMedNom: resp[i].UniMedNom,
            idDataStorage: resp[i].idDataStorage,
            NombreDS: resp[i].NombreDS,
            UrlDS: resp[i].UrlDS,
            URLBanner: resp[i].URLBanner,
            Habilitado: resp[i].Habilitado,
          });
          //console.log(banner);
        }
        if (contador == 3) {
          if (banner.length > 0) {
            this.contenedor.push({ banner: banner });
            banner = [];
          }
          contador = 0;
        }
      }
      if (banner.length > 0) {
        this.contenedor.push({ banner: banner });
      }
    });
    //console.log(this.contenedor);
  }
  irAProductos(item) {
    if (item.idItem == null) {
      if (item.Marca.length == 0) {
        this.router.navigate(["/home/products", item.Codigo,"0","TODAS", 0,0,0,1]);
      } else {
        this.router.navigate(["/home/products", item.Codigo,"0", item.Marca,0,0,1]);
      }
    } else {
      this.router.navigate(["/home/product", item.idItem]);
    }
  }
}
